export default __webpack_public_path__ + "static/media/Robusta-1.40e29634.jpg";